module.exports = __webpack_public_path__ + "static/media/BuyTicketIcon-Inactive.809e7c3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/tepual/home/BuyTicketIcon-Inactive.svg
// module id = 1659
// module chunks = 0